import { Billingmemberships, Boost, Easydata, Engage, Insightful, Marketing, Martialimg, Mobileapp, Progresstracking, Simplify, Swimmanagement, Swimscheduling } from "../assets/images/images";

const martialArtsData = {
    heading: "The Best Software for Martial Arts Studio",
    subtitle:
        "EasyMembr provides specialized software for martial arts studios, helping you streamline class schedules, track belt progressions, manage memberships, and automate payments—so you can focus on teaching discipline and developing skills.",
    trialText: " Unlock your access",
    demoText: "Book A Demo",
    imageSrc: Martialimg,
    FeatureHead: "Features of Martial Arts Studio Management: Organized Training & Member Growth",
    FeatureDesc: "Unlock tools built to help martial arts schools run smoothly, boost engagement, and grow efficiently.",
    FeaturesDetails: [
        {
            id: 1,
            title: "Class Scheduling and Student Bookings",
            description: [
                "Easymembr lets you schedule martial arts classes for all belt levels with ease using an intuitive calendar.",
                "Quickly manage reschedules, rank-based class enrollments, and waitlists in real-time.",
                "Students or parents can book classes via the app or website, increasing flexibility and attendance.",
            ],
            image: Swimscheduling
        },
        {
            id: 2,
            title: "Student Progress Tracking & Secure Profiles",
            description: [
                "Track student attendance, belt rank, grading history, and notes for personalized coaching.",
                "Create detailed profiles for every member, storing contact info and emergency details.",
                "Ensure security of student records with encrypted and compliant data handling.",
            ],
            image: Progresstracking
        },
        {
            id: 3,
            title: "Billing, Memberships & Payment Integration",
            description: [
                "Connect your studio to payment gateways to accept credit cards, UPI, net banking, and wallets.",
                "Automate monthly membership billing and package payments to save time and avoid delays.",
                "Track late payments and send reminders automatically.",
            ],
            image: Billingmemberships

        },
        {
            id: 4,
            title: "Insightful Analytics and Belt Progress Reports",
            description: [
                "Monitor student attendance, active memberships, and grading progress with built-in dashboards.",
                "Generate rank promotion reports to evaluate readiness for belt testing.",
                "Use data insights to improve training schedules, performance, and business results.",
            ],
            image: Insightful

        },
        {
            id: 5,
            title: "Mobile App for Parents, Students & Instructors",
            description: [
                "Provide a mobile experience where students and parents can check schedules, track progress, and make payments.",
                "Send notifications for class changes, test dates, and promotions.",
                "Allow instructors to update attendance and grading directly from their phone.",
            ],
            image: Mobileapp

        },
        {
            id: 6,
            title: "Instructor Management & Automated Payroll",
            description: [
                "Assign instructors to belt-specific classes and track their hours automatically.",
                "Generate payroll based on sessions taught, attendance, and performance metrics.",
                "Use real-time feedback from students and guardians to improve coaching quality.",
            ],
            image: Swimmanagement

        },
    ],
    HighlighCardDetails: [
        {
            id: 1,
            subtitle: "BEST SOFTWARE FOR MARTIAL ARTS",
            title: "Book a Demo Now!",
            description: [
                "Modernize your martial arts studio with smart tools. Start a free trial and experience stress-free studio management!"
            ],
            image: "https://fitgymsoftware.com/images/martial-arts-studio-software/cta-image.webp",
            links: [
                "Get Full Access Now!",
                "Book A Demo",
                "Check Pricing"
            ],
        }
    ],

    AdvantageHeadText: "Advantages of Our Martial Arts Studio Software",
    AdvantageDescText: "EasyMembr’s all-in-one platform boosts student retention, streamlines operations, and helps you grow a stronger martial arts community.",

    featuresData: [
        {
            title: "Seamless Setup and Data Import",
            description: [
                "Quickly migrate your student records, payments, and history with support from our team.",
                "Review financial trends, class activity, and belt progression with clear reports.",
                "Customize dashboards to display key performance metrics relevant to your studio."],
            icon: Engage
        },
        {
            title: "Improved Student Engagement",
            description: [
                "Create student journeys with clear progression paths, regular updates, and motivational messages.",
                "Send martial arts tips, announcements, and class materials to keep students engaged outside class.",
                "Reward achievements with digital certificates and promotions."],
            icon: Marketing
        },
        {
            title: "Belt & Class Management",
            description: [
                "Sort classes by belt level, age group, or skill category to simplify scheduling.",
                "Automate belt progression alerts and testing reminders.",
                "Track class capacity, no-shows, and rank-based participation efficiently."],
            icon: Simplify
        },
        {
            title: "Built-In Marketing & Notifications",
            description: [
                "Launch referral programs and offer discounts to new students via SMS or WhatsApp.",
                "Promote grading events, tournaments, or workshops directly from the dashboard.",
                "Send automated messages for birthdays, rank achievements, and renewals."],
            icon: Easydata
        },
        {
            title: "Ongoing Support & Staff Analytics",
            description: [
                "Get multilingual customer support whenever you need it.",
                "Track instructor performance, student feedback, and training effectiveness.",
                "Receive timely updates and product enhancements with zero disruption."],
            icon: Boost

        },
    ]
};

export default martialArtsData;